module.exports = __webpack_public_path__ + "static/media/2.c5db1385.gif";